function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import './header.scss';
import 'magnific-popup';
import MmenuLight from 'mmenu-light';
export default /*#__PURE__*/_asyncToGenerator(function* () {
  const menuHolder = document.querySelector('#nav');

  if (menuHolder) {
    const menu = new MmenuLight(menuHolder, '(max-width: 991px)');
    menu.navigation({
      selected: 'is-active',
      title: 'Menu',
      theme: 'dark'
    });
    const drawer = menu.offcanvas({
      position: 'left'
    });
    document.querySelector('a[href="#nav"]').addEventListener('click', event => {
      event.preventDefault();
      drawer.open();
    });
  }

  $(window).scroll(function () {
    if ($(window).scrollTop() >= 59) {
      $('.header__header').addClass('header__header--sticky');
    } else {
      $('.header__header').removeClass('header__header--sticky');
    }
  });
  $('.image-popup-vertical-fit').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery: {
      enabled: true
    },
    zoom: {
      enabled: true,
      duration: 300,
      // Duration of the effect, in milliseconds
      easing: 'ease-in-out',
      // CSS transition easing function
      opener: function (openerElement) {
        return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  });
});